/** Empty bands are skipped: they take no rows and get no separator. */
export const createBandLayout = (bands) => {
    const visible = bands.filter((b) => b.rows > 0);
    const starts = [];
    let total = 0;
    for (const [i, band] of visible.entries()) {
        if (i > 0)
            total += 1;
        starts.push(total);
        total += band.rows;
    }
    const startById = new Map(visible.map((b, i) => [b.id, starts[i] ?? 0]));
    const bandIndexAt = (row) => {
        let lo = 0;
        let hi = starts.length - 1;
        while (lo < hi) {
            const mid = (lo + hi + 1) >> 1;
            if ((starts[mid] ?? 0) <= row)
                lo = mid;
            else
                hi = mid - 1;
        }
        return lo;
    };
    const isSeparator = (row) => {
        const i = bandIndexAt(row);
        return i < visible.length - 1 && row - (starts[i] ?? 0) >= (visible[i]?.rows ?? 0);
    };
    const locate = (row) => {
        if (isSeparator(row))
            return undefined;
        const i = bandIndexAt(row);
        return { band: visible[i]?.id ?? "", row: row - (starts[i] ?? 0) };
    };
    const nearestDataRow = (row, direction) => (isSeparator(row) ? row + direction : row);
    const locateData = (row, direction) => locate(nearestDataRow(row, direction)) ?? { band: "", row: 0 };
    return {
        total,
        isSeparator,
        separatorRows: starts.slice(1).map((start) => start - 1),
        locate,
        locateSpan: (y, height) => ({ from: locateData(y, 1), to: locateData(y + height - 1, -1) }),
        rowOf: (band, row) => (startById.get(band) ?? 0) + row,
        dataIndex: (row) => row - bandIndexAt(row),
        bandAbove: (row) => (isSeparator(row) ? visible[bandIndexAt(row)] : undefined),
        nearestDataRow,
    };
};
/** The band's row count after its lower separator moved `deltaY` pixels, snapped to whole rows. */
export const resizedRows = (band, startRows, deltaY, rowHeight) => {
    const rows = startRows + Math.round(deltaY / rowHeight);
    return Math.min(band.maxRows ?? Number.POSITIVE_INFINITY, Math.max(band.minRows ?? 1, rows));
};
//# sourceMappingURL=bands.js.map